import { GET_DELETE_USER_REQUEST_BY_ID } from "../actions/types";

const initialState = {
  deleteUserRequest: {},
};

const deleteUserRequestsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_DELETE_USER_REQUEST_BY_ID:
      return {
        ...state,
        deleteUserRequest: action.payload,
      };

    default:
      return state;
  }
};

export default deleteUserRequestsReducer;
